module.exports = __webpack_public_path__ + "img/dicas.0e9853b4.png";